import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import jwt_decode from "jwt-decode";

// import 'rxjs/Rx';
import { environment } from 'src/environments/environment';
// import { environment } from 'src/environments/environment.prod';
import { map } from 'rxjs/operators'
import { CommonService } from 'src/app/service/common-service';

interface JwtPayload {
  [x: string]: string;
  Employee_Code: string;
  Clients: any;
}
@Injectable({
  providedIn: 'root'
})
export class MenuMappingService {

  constructor(private http: HttpClient) { }
  getClientList():any {
    const token = sessionStorage.getItem('access_token');
    // let data = jwt_decode(sessionStorage.getItem('access_token'));

    return this.http.get(environment.ApiUrl + '/api/Get_All_Clients_User_Menu_Mapping').pipe(map(res => res));
  }

  getUserList(id, role):any {
    const token = sessionStorage.getItem('access_token');
    // console.log('token : ', token);
    // let data = jwt_decode(sessionStorage.getItem('access_token'));
    //Get_User_List_Menu_Mapping/id/name?id=1&name=Client Supervisor
    return this.http.get(environment.ApiUrl + '/api/Get_User_List_Menu_Mapping/?id=' + id + '&name=' + role).pipe(map(res => res));//subiksh
  }

  //api/Get_Menu_List_User_Menu_Mapping
  getMenuList():any {
    const token = sessionStorage.getItem('access_token');
    // let data = jwt_decode(sessionStorage.getItem('access_token'));
    //Get_User_List_Menu_Mapping/id/name?id=1&name=Client Supervisor
    return this.http.get(environment.ApiUrl + '/api/Get_Menu_List_User_Menu_Mapping').pipe(map(res => res));
  }

  getAllUsersWithMenu():any {
    // http://172.19.9.101:1001/api/Get_All_Clients_User_Menu_Mapping
    const token = sessionStorage.getItem('access_token');
    // let data = jwt_decode(sessionStorage.getItem('access_token'));
    //Get_User_List_Menu_Mapping/id/name?id=1&name=Client Supervisor
    // Get_All_Clients_User_Menu_Mapping
    return this.http.get(environment.ApiUrl + '/api/Get_User_Menu_List').pipe(map(res => res));
    // return this.http.get(environment.ApiUrl + '/api/Get_User_List_Menu_Mapping/id/name?id=' + data.User_Id + '&name=' + data.Role_Name).pipe(map(res => res));
  }

  saveMenuSubmenu(obj):any {
    // http://172.19.9.101:1001/api/Save_Menu_SubMenu_Config_List_For_User
    const token = sessionStorage.getItem('access_token');

    return this.http.post(environment.ApiUrl + '/api/Save_Menu_SubMenu_Config_List_For_User', obj).pipe(map(res => res));
  }

  getMenuForUser():any {
    const token = CommonService.decryptData(sessionStorage.getItem('access_token'));
    //let data = jwt_decode(token);
           const data = jwt_decode<JwtPayload>(token);
    console.log('getMenuForUser data : ', data);
    data.Clients = JSON.parse(sessionStorage.getItem('access_client_data'))
    // Added Client id
    return this.http.get(environment.ApiUrl + '/api/Get_Menu_List_By_Username/' + data.User_Id + '/'+ data.Clients[0].Client_Id).pipe(map(res => res));
  }
}
